var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button',{staticClass:"btn btn-primary",on:{"click":_vm.importFile}},[_vm._v("Import")])
}
var staticRenderFns = []

export { render, staticRenderFns }